module.exports = __webpack_public_path__ + "static/media/icon-facebook.eb6b47df.svg";